export enum OrganizationVersions {
  CorpV1 = 1,
}
